import { authFetch } from "./authApi";

async function requestJson(path, options = {}) {
  const response = await authFetch(path, options);
  if (!response.ok) {
    const body = await response.text();
    throw new Error(`API ${response.status} on ${path}: ${body || response.statusText}`);
  }
  return response.json();
}

export async function fetchCategories() {
  return requestJson("/categories");
}

export async function createCategory(payload) {
  return requestJson("/categories", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function updateCategory(categoryId, payload) {
  return requestJson(`/categories/${encodeURIComponent(categoryId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function deleteCategory(categoryId) {
  return requestJson(`/categories/${encodeURIComponent(categoryId)}`, {
    method: "DELETE",
  });
}
